export const FLOW_TYPES = {
  NEW_REGISTRATION: "NEW_REGISTRATION",
  EDIT_PERSONAL: "EDIT_PERSONAL",
  EDIT_COMPANY: "EDIT_COMPANY",
  EDIT_DOCUMENTS: "EDIT_DOCUMENTS",
  UPDATE_SCR: "UPDATE_SCR",
  CHANGE_OF_OWNERSHIP: "CHANGE_OF_OWNERSHIP",
};

const ROUTES = {
  STEP_ONE: "/digital-onboarding/step-one",
  STEP_TWO: "/digital-onboarding/step-two",
  STEP_THREE: "/digital-onboarding/step-three",
  STEP_FOUR: "/digital-onboarding/step-four",
  STEP_FIVE: "/digital-onboarding/step-five",
  STEP_SIX: "/digital-onboarding/step-six",
};

// Each entry: { route, screen? }
// route  — the React Router path to navigate to
// screen — the internal screen the step component should open to (optional)
export const FLOWS = {
  [FLOW_TYPES.NEW_REGISTRATION]: [
    { route: ROUTES.STEP_ONE,   screen: "mobile" },
    { route: ROUTES.STEP_TWO,   screen: "info" },
    { route: ROUTES.STEP_THREE, screen: "info" },
    { route: ROUTES.STEP_FOUR,  screen: "personal" },
    { route: ROUTES.STEP_FIVE },
    { route: ROUTES.STEP_SIX },
  ],

  // Edit sub-flows launched from the review step (Step 5)
  [FLOW_TYPES.EDIT_PERSONAL]: [
    { route: ROUTES.STEP_FOUR, screen: "personal" },
    { route: ROUTES.STEP_FIVE },
  ],
  [FLOW_TYPES.EDIT_COMPANY]: [
    { route: ROUTES.STEP_FOUR, screen: "company" },
    { route: ROUTES.STEP_FIVE },
  ],
  [FLOW_TYPES.EDIT_DOCUMENTS]: [
    { route: ROUTES.STEP_FOUR, screen: "documents" },
    { route: ROUTES.STEP_FIVE },
  ],
};
